<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form class="form" :model="self_form" :rules="rules" ref="form" label-width="12%">
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>类目选择</span>
        </div>
        <div class="conf">
          <el-form-item label="商品类型：">
            <el-select v-model="itemType">
              <el-option v-for="op in itemTypeOpts" :key="op.value" :value="op.value" :label="op.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="itemBizType">
            <el-radio-group v-model="self_form.itemBizType">
              <el-radio v-for="item in itemBizTypeOpts" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商品分类：" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" v-model="self_form.categoryIds" :isSupportAi="true" :platform="platform" :baseItemId="baseItemId"  @change="categoryChange" />
            </div>
          </el-form-item>
          <el-form-item label="商品属性:" prop="channelPv">
            <UseCategoryTemplate :detailHasCategory="detailHasCategory" :supportTemplate="false" :baseItemId="baseItemId" :categoryIds.sync="self_form.categoryIds" :platform="platform" :propValues="self_form.channelPv">
              <CategoryProps ref="cateprops" v-model="self_form.channelPv" :lastLevelCateGory="lastLevelCateGory" />
            </UseCategoryTemplate>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>商品信息</span>
        </div>
        <div class="conf">
          <el-form-item label="引用套图:" v-if="showGroupImages">
            <div class="ft-12">
              商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link>
            </div>
            <GroupImagesList
              :baseItemId="baseItemId"
              @useOk="useGroupImages"
              :specifications="specifications"
              @getList="getGroupImagesList"
            ></GroupImagesList>
          </el-form-item>
          <el-form-item label="商品图片：" prop="images">
            <div class="imgs-wrp">
              <div class="ft-12">
                铺货时只取主图，拖动可调整顺序
                <BatchEditImages v-model="self_form.images" refName="images" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages>
              </div>
              <MutiImgUpload
                ref="images"
                v-model="self_form.images"
                :limitSize="10 * 1024 * 1024"
                :aspectRatio="[1.33, 1, 0.75]"
                aspectRatioText="4:3、1:1、3:4"
                :size="150"
                :mainImgNums="0"
                limitSuffix=".jpg,.png,.jpeg"
                :supportAiRetry="true"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <span>提示：第1张作为商品主图，前9张发布到咸鱼App。图片大小需10M以下，建议上传PNG格式，图片比例为4:3、1:1、3:4三种格式，</span>
              <span style="color: #faad14">咸鱼APP发布的商品编辑图片会有失真的风险，请谨慎操作</span>
            </div>
          </el-form-item>
          <el-form-item label="商品标题：" prop="title">
            <el-input type="text" placeholder="请输入商品标题，最多允许输入30个汉字" v-model="self_form.title">
              <span slot="suffix" style="margin-right: 6px">{{ titleLength }}/60</span>
            </el-input>
          </el-form-item>
          <el-form-item label="商品描述：" prop="content">
            <el-input type="textarea" :rows="4" placeholder="请输入商品描述" v-model="self_form.content" maxlength="5000" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">提示：建议填写该商品的品牌词、品类词、商品属性能够帮助商品更好的被搜索</div>
          </el-form-item>
          <el-form-item label="发货地址：" prop="shopAddress">
            <el-select-address ref="addressRef" :widths="['120px', '104px', '104px', -1]" v-model="self_form.shopAddress" />
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>价格库存</span>
        </div>
        <div class="conf">
          <el-form-item label="商品规格：">
            <RuleSortBtn :specifications.sync="specifications" />
            <SpecsValuesSort :specifications.sync="specifications" />
            <FormItemSpecification
              ref="specificationRef"
              v-model="specifications"
              :platform="platform"
              @fieldChanged="specificationsFieldChanged"
            />
          </el-form-item>
          <el-form-item v-if="skuList.length" label="规格明细：">
            <FormItemSkuList
              :baseItemId="baseItemId"
              :specifications="specifications"
              skuSpecificationsKey="skuSpecifications"
              :tableCols="skuTableCols"
              v-model="skuList"
              skuOuterIdKey="outerId"
              :showBindSkuOuterId="true"
              @fieldChanged="validPage"
            >
            </FormItemSkuList>
            <template v-if="specificationsValidResult !== true">
              <div class="el-form-item__error">{{ specificationsValidResult }}</div>
            </template>
          </el-form-item>
          <el-form-item label="原价：" prop="originalPrice">
            <el-input-digit v-model.number="self_form.originalPrice" nullable placeholder="0.00" format="#.##" style="width: 150px">
              <span>¥</span>
            </el-input-digit>
          </el-form-item>
          <el-form-item label="售价：" prop="price">
            <el-input-digit v-model.number="self_form.price" nullable placeholder="0.00" format="#.##" style="width: 150px">
              <span>¥</span>
            </el-input-digit>
          </el-form-item>
          <el-form-item label="库存：" prop="stock">
            <el-input-digit v-model.number="self_form.stock" nullable format="#" style="width: 150px"></el-input-digit>
            <!-- <el-checkbox style="margin-left: 20px" v-model="self_form.autoPublish">售罄自动上架</el-checkbox> -->
          </el-form-item>
          <el-form-item label="商家编码：" prop="outerId">
            <el-input type="text" placeholder="最多允许输入32个汉字（64个字符）" v-model="self_form.outerId">
              <span slot="suffix" style="margin-right: 6px">{{ outerIdLength }}/64</span>
            </el-input>
          </el-form-item>
          <el-form-item label="成色：" prop="stuffStatusType">
            <el-select v-model="self_form.stuffStatusType">
              <el-option v-for="op in stuffStatusTypeOpts" :key="op.value" :value="op.value" :label="op.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="self_form.stuffStatusType" prop="stuffStatus">
            <el-radio-group v-model="self_form.stuffStatus">
              <el-radio v-for="op in stuffStatusOpts" :key="op.value" :label="op.value">{{ op.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>物流信息</span>
        </div>
        <div class="conf">
          <el-form-item label="物流信息：" prop="expressFees">
            <div class="expressFee-row" v-for="shop in shopAllList" :key="shop.id">
              <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
              <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px">
                <el-image :src="shop.channelIcon" style="width: 18px; height: 18px"></el-image>
              </el-tooltip>
              <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
              <el-radio-group v-model="expressFees[shop.id].expressFeeType">
                <el-radio :label="1">包邮</el-radio>
                <el-radio :label="2">统一运费</el-radio>
                <el-radio :label="3" disabled>
                  运费模版
                  <el-tooltip placement="top">
                    <div slot="content">
                      接口不支持设置运费模版，请前往闲管家后台进行配置，新增运费模版（可点击跳转，
                      <el-link href="https://goofish.pro/settings/freight/list" target="_blank">链接</el-link>
                      )
                    </div>
                    <i style="margin-left: 5px; margin-right: 5px" class="el-icon-question" />
                  </el-tooltip>
                </el-radio>
              </el-radio-group>
              <div>
                <el-input-digit
                  v-if="expressFees[shop.id].expressFeeType === 2"
                  v-model.number="expressFees[shop.id].expressFee"
                  format="#.##"
                  placeholder="请输入统一运费"
                  style="width: 150px"
                ></el-input-digit>
              </div>
            </div>
          </el-form-item>
        </div>
      </section>

      <!-- 上架设置 -->
      <section>
        <div class="title ft-12">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item label="上架设置:" prop="isOnshelf" :rules="[{ required: true, message: '请输入上架设置', trigger: 'blur' }]">
            <el-radio-group v-model="self_form.isOnshelf">
              <el-radio :label="1">立即上架</el-radio>
              <el-radio :label="3">放入草稿箱</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </section>
    </el-form>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue';
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue';
import CategoryInput from '../PlatformCategoryInput/index.vue';
import CategoryProps from './components/CategoryProps.vue';
import UseCategoryTemplate from '../UseCategoryTemplate.vue'
import FormItemSpecification from './components/FormItemSpecification.vue';

import { specification_mixin } from '../FormItemSpecification';
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import RULES from './rules.js';
import { itemTypeOpts, itemBizTypeOpts, stuffStatusOpts, stuffStatusTypeOpts } from './config';
import { getBytesCount } from '@utils/data';
import { getDistributionConfig } from '@servers/prod/conf/index.js';
import { getXianyuRegionData } from '@/servers/prod/center/xianyu.js';
import { cloneDeep, isEmpty } from 'lodash';


export default {
  mixins: [specification_mixin, validateMixin, shopListMixin],
  provide: {
    platform: 'xy',
  },
  inject: {
    isGroupPuhuo: { default: false },
  },
  components: {
    MutiImgUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    CategoryProps,
    UseCategoryTemplate,
    FormItemSpecification,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    openSource:{
      type:String,
      default:''
    },
  },

  data() {
    return {
      platform: 'xy',
      itemTypeOpts,
      itemBizTypeOpts,
      stuffStatusOpts,
      stuffStatusTypeOpts,
      itemType: 1,
      self_form: {
        categoryIds: [],
        channelPv: [],
        images: [],
        shopAddress: [],
        title: '',
        content: '',
        originalPrice: '',
        price: '',
        stock: '',
        outerId: '',
        stuffStatusType: 0,
        stuffStatus: '',
        expressFeeType: 1,
        expressFee: '',
        isOnshelf: '',
      },
      expressFees: {},
      lastLevelCateGory: {},
      rules: RULES(this),
      detailHasCategory: [],
      showGroupImages: true,
      skuSpecificationsKey: 'skuSpecifications',
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      specification_needImg: false, // 规格需要校验图片是否补充
      originalTemplateConfig: null, // 原始运费模板配置（用于保存时恢复未显示店铺的数据）
    };
  },
  computed: {
    titleLength() {
      return getBytesCount(this.self_form.title || '');
    },
    outerIdLength() {
      return getBytesCount(this.self_form.outerId || '');
    },
    shopId() {
      return this.$store.getters.shops_getCategoryPropShopId(this.platform);
    },
    shopAllList() {
      let list = this.$store.getters.get_AllShops_BySource(this.platform);
      if(this.openSource === 'shopGoods'){
          list = list.filter(item => item.id == this.form.shopId)
      }
      return list
    },
    skuTableCols() {
      let openSource = this.openSource
      let isShowPreviewPrice = true;
      if(['taskCenter','previewPublish'].includes(openSource)){
          isShowPreviewPrice = false
      }
      let cols = [
        {
          prop: 'price',
          attrs: { label: '价格' },
          input: { type: 'number' },
          previewPrice: isShowPreviewPrice
        },
        {
          prop: 'stock',
          attrs: { label: '库存' },
          input: { type: 'number' },
        },
        this.openSource != 'shopGoods' ? { prop: 'outerId', attrs: { label: '商家编码' } } : null,
      ];
      return cols.filter(Boolean);
    },
  },
  watch: {
    form: {
      handler(v) {
        if (isEmpty(v)) return;
        const data = cloneDeep(v);
        const { specifications, stuffStatus, expressFee } = data;
        this.skuList = [];
        this.specifications = specifications || [];
        this.initExpressFees(data);
        // 保存原始 templateConfig，用于保存时恢复未显示店铺的数据
        if (data.templateConfig && data.templateConfig.length) {
          this.originalTemplateConfig = cloneDeep(data.templateConfig);
        }
        this.lastLevelCateGory = {
          spBizType: data.spBizType,
          itemBizType: data.itemBizType,
          channelCatId: data.channelCatId,
          cid: data.categoryId,
        }
        this.detailHasCategory = data.categoryIds
        this.$set(this, 'self_form', {
          ...this.self_form,
          ...data,
          stuffStatusType: stuffStatus > 0 || stuffStatus == -1 ? 1 : 0,
          expressFeeType: expressFee > 0 ? 2 : 1,
          itemBizType: data.itemBizType || 2
        }); 
        this.$nextTick(() => {
          this.validPage();
        });
        // this.getRegionData();
        this.getConf();
      },
      immediate: true,
    },
  },
  methods: {
    categoryChange(categoryIds, categoryNames, lastLevelCateGory) {
      // console.log(cloneDeep(lastLevelCateGory), '----cloneDeep(lastLevelCateGory)---')
      this.lastLevelCateGory = cloneDeep(lastLevelCateGory);
      const { spBizType, itemBizType, channelCatId, cid } = lastLevelCateGory || {};
      this.self_form.itemBizType = itemBizType;
      this.self_form.spBizType = spBizType;
      this.self_form.categoryId = cid;
      this.self_form.channelCatId = channelCatId;
    },
    initExpressFees(form) {
      const templateConfig = form.templateConfig;
      const expressFees = {};
      this.shopAllList.map(shop => {
        const findItem = templateConfig.find(item => shop.id === item.shopId);
        expressFees[shop.id] = {
          expressFeeType: findItem?.expressFee > 0 ? 2 : 1,
          expressFee: findItem?.expressFee || 0,
          shopId: shop.id,
        };
      });
      this.$set(this, 'expressFees', expressFees);
    },
    handleTemplateConfig() {
      return Object.values(this.expressFees).map(item => {
        return {
          shopId: item.shopId,
          expressFee: item.expressFeeType === 1 ? 0 : item.expressFee, // 处理运费逻辑
        };
      });
    },
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : [];
    },
    async method_getFormData() {
      const valid = await this.validPage();
      if (!valid) {
        this.$message.error('请完善表单');
        return false;
      }

      const _formData = cloneDeep(this.self_form);
      // 获取规格和SKU数据
      const [specifications, skuList] = this.getSpecificationData();
      const { addressRef } = this.$refs;

      // 深拷贝表单数据并合并规格数据
      const formData = {
        ..._formData,
        specifications,
        skuList,
        stuffStatus: _formData.stuffStatusType === 0 ? _formData.stuffStatusType : _formData.stuffStatus, // 处理成色状态
        shopAddress: [addressRef.province, addressRef.city, addressRef.area], // 处理发货地址
        templateConfig: this.mergeHiddenShopData(this.handleTemplateConfig(), this.originalTemplateConfig, this.shopList),
      };
      // 清理临时字段
      delete formData.stuffStatusType;
      console.log(specifications, formData, '--specifications--_formdata---');
      // return;
      return formData;
    },

    async getRegionData(parentCode) {
      const addressData = await getXianyuRegionData({ parentCode: parentCode || 0 });
    },

    useGroupImages(data, type) {
      const { mainImages = [], images = [], speImages = [] } = data;
      let pic = [],
        description = [];
      if (type === 'add') {
        pic = [...this.self_form.images].filter(Boolean);
        description = [...this.self_form.descInfo];
      }
      if (mainImages.length) {
        this.self_form.images = [...pic, ...mainImages].filter(Boolean).slice(0, 9);
      }
      if (images.length) {
        this.self_form.descInfo = [...description, ...images].filter(Boolean).slice(0, 20);
      }
      const firstSpec = this.specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
        firstSpec.values.forEach(specValue => {
          // 如果是新增模式且已有图片，则跳过
          if (type === 'add' && specValue.imageUrl) {
            return;
          }

          // 查找匹配的图片
          const matchedImage = speImages.find(img => img.name === specValue.value);
          if (matchedImage) {
            specValue.imageUrl = matchedImage.imgUrl;
          }
        });
      }
    },
    getGroupImagesList(list) {
      this.showGroupImages = !!list?.length;
    },
    editGroupImages() {
      this.changeToBase('openGroupImgs');
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({ shopType: this.platform });
      if(!this.self_form.isOnshelf)  {
        this.self_form.isOnshelf = res?.shelfState || 1;
      }
      if(!this.self_form.shopAddress?.length && res.xyShopAddress)  {
        this.self_form.shopAddress = res.xyShopAddress.split(',');
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scope>
.expressFee-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>